import http from "../services/httpService";
import httpServiceDownloads from "../services/httpServiceDownloads";
import httpNoAuthService from "../services/httpNoAuthService";
import httpNoAuthServiceDownloads from "../services/httpNoAuthServiceDownloads";


export async function getChoices() {
    const resp = await httpNoAuthService.get(`/summer_school/choices/`)
    return resp.data
}

export async function getExtraCurriculars() {
    const resp = await httpNoAuthService.get(`/summer_school_extra_curriculars/`)
    return resp.data
}

export async function getRegistrations() {
    const resp = await http.get(`/summer_school_registrations/`)
    return resp.data
}

export async function getRegistration(id) {
    const resp = await http.get(`/summer_school_registrations/${id}/`)
    return resp.data
}

export async function getRegistrationWithSecret(id, secret) {
    const resp = await httpNoAuthService.get(`/summer_school_registrations/${id}/?secret=${secret}`)
    return resp.data
}

export async function postRegistration(data, currentUserId) {

    let authService = httpNoAuthService
    if (currentUserId) authService = http

    const resp = await authService.post('/summer_school_registrations/', data)
    return resp.data
}

export async function patchRegistration(data, currentUserId) {
    let authService = httpNoAuthService
    if (currentUserId) authService = http

    const resp = await authService.patch(`/summer_school_registrations/${data.id}/?secret=${data.secret}`, data)
    return resp.data
}

export async function confirmRegistration(data) {
    const resp = await httpNoAuthService.post(`/summer_school_registrations/${data.id}/confirm/?secret=${data.secret}`, data)
    return resp.data
}

export async function sendInvoice(id) {
    const resp = await http.post(`/summer_school_registrations/${id}/send_invoice/`)
    return resp.data
}


export async function addRegistrationStudentPhoto(formData, id, secret, currentUserId) {
    let authService = httpNoAuthService
    if (currentUserId) authService = http
    const resp = await authService.post(`/summer_school_registrations/${id}/add_student_photo/?secret=${secret}`, formData)
    return resp.data
}

export async function deleteRegistration(id, secret, currentUserId) {
    let authService = httpNoAuthService
    if (currentUserId) authService = http
    const resp = await authService.delete(`/summer_school_registrations/${id}/?secret=${secret}`)
    return resp.data
}

export async function getStudentData(studentId) {
    const resp = await http.get(`/summer_school_student_data/${studentId}/`)
    return resp.data
}

export async function getSummerSchoolCourses() {
    const resp = await http.get(`/summer_school_courses/`)
    return resp.data
}

export async function getRegistrationsExcel() {
    const resp = await httpServiceDownloads.get(`/summer_school_registrations/excel/`)
    return resp.data
}

export async function refreshInvoiceLines(id) {
    const resp = await http.post(`/summer_school_registrations/${id}/refresh_invoice_lines/`)
    return resp.data
}


export async function getInvoicePDF(id, forceRegenerate) {
    const resp = await httpServiceDownloads.get(`/summer_school_registrations/${id}/invoice_pdf/?force_regenerate=${forceRegenerate}`);
    return resp.data;
}

export async function getInvoicePDFWithSecret(id, secret) {
    const resp = await httpNoAuthServiceDownloads.get(`/summer_school_registrations/${id}/invoice_pdf/?secret=${secret}`);
    return resp.data;
}

export async function retrieveRegistration(data) {
    const resp = await httpNoAuthService.post(`/summer_school/retrieve_registration/`, data)
    return resp.data
}